import React, { useState } from 'react';
import './About.css';

function About() {
  const [activeService, setActiveService] = useState('technology');

  const serviceData = {
    technology: {
      title: "Technology",
      content: "We harness the power of cutting-edge technologies to drive innovation and efficiency. By integrating advanced tools and intelligent systems, we empower our clients to stay ahead in a rapidly evolving digital landscape.",
      icon: "/images/class1.png"
    },
    customized: {
      title: "Customized Solutions",
      content: "We understand that every business is unique. Our customized solutions are designed to align precisely with your specific needs and goals, ensuring a strategic fit that drives measurable success.",
      icon: "/images/class2.png"
    },
    confidentiality: {
      title: "Client Confidentiality",
      content: "Client trust is at the heart of everything we do. We adhere to the highest ethical standards, safeguarding every interaction with unwavering confidentiality and discretion. Our secure practices ensure a trusted environment where your information remains protected.",
      icon: "/images/class3.png"
    },
    excellence: {
      title: "Timely Excellence",
      content: "We deliver excellence with precision and punctuality, ensuring that your critical deadlines are met without sacrificing quality. Our commitment to timeliness empowers your business to move forward with confidence and efficiency.",
      icon: "/images/class4.png"
    }
  };

  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/About_us.png')" }}
      >
        <div className="hero-text-container">
          <h1>About Us</h1>
          <p>FINTEXL is a client-focused consulting firm dedicated to financial clarity, strategic compliance, and sustainable growth. <br />
            We empower startups, SMEs, and enterprises with innovative CFO services, tech-enabled solutions, and deep regulatory expertise. <br />
            From vision to execution — we help you scale smarter, faster, and stronger.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Your Trusted Partner in Tax, Compliance & Financial Strategy.</h2>
         <p>FINTEXL is a trusted Hyderabad-based financial advisory firm helping startups, SMEs, and corporates strengthen their financial strategies through Virtual CFO services, full compliance support, and smart business consulting.</p>
<p>Our mission is to empower businesses, ensure legal compliance, and deliver real financial growth with clarity and confidence.</p>
<p>With deep experience and a client-first approach, FINTEXL combines expert financial planning, regulatory advice, and digital solutions to deliver a smooth consulting journey.</p>

        </div>
      </section>

      {/* Work Process Section */}
      <section className="work-process-section">
        <h2 className="section-title">Our Work <span>Process</span></h2>
        <p className="section-subtitle">
         FINTEXL Consulting works with businesses to solve challenges and find new ways to grow.We help businesses overcome challenges and unlock new opportunities for success.
        </p>
        <div className="work-process-steps">
          <div className="step">
            <img src="/images/work2.png" alt="Share Your Goal" />
            <h3>Share Your Goal</h3>
            <p>How all this mistaken our idea complete system.</p>
          </div>
          <div className="step">
            <img src="/images/work1.png" alt="Find a Challenges" />
            <h3>Find a Challenges</h3>
            <p>Denouncing pleasure praising expound actual.</p>
          </div>
          <div className="step">
            <img src="/images/work3.png" alt="Get a Solution" />
            <h3>Get a Solution</h3>
            <p>There anyone all loves desires obtain pain itself.</p>
          </div>
        </div>
      </section>

      {/* Best in Class Services */}
      <section className="services-section">
        <h2 className="section-title">Best in <span>Class Services</span></h2>
        <p className="section-subtitle">
         At FINTEXL Consulting, we deliver forward-thinking solutions that empower clients to navigate challenges and seize opportunities in today’s dynamic global economy.
        </p>
        <div className="service-highlights">
          {Object.keys(serviceData).map((key) => (
            <div
              key={key}
              className={`service-box ${activeService === key ? 'active' : ''}`}
              onClick={() => setActiveService(key)}
            >
              <img src={serviceData[key].icon} alt={serviceData[key].title} />
              <h3>{serviceData[key].title}</h3>
            </div>
          ))}
        </div>
        <div className="service-description">
          <p>{serviceData[activeService].content}</p>
        </div>
      </section>

      {/* Milestones Section */}
      <section className="milestones-section">
        <h2 className="milestones-title">Our Milestones</h2>
        <div className="timeline">
          <div className="timeline-year">
            <div className="icon"><img src="/images/milestone1.png" alt="2023" /></div>
            <h3>2023</h3>
            <p>FINTEXL was founded in Hyderabad with a mission to empower startups and SMEs with accessible, tech-driven financial advisory services. The foundation was laid with a small team and big ambition.</p>
          </div>
          <div className="timeline-year">
            <div className="icon"><img src="/images/milestone2.png" alt="2024" /></div>
            <h3>2024</h3>
            <p>With client trust and word-of-mouth growth, FINTEXL expanded its services across Telangana and Andhra Pradesh, onboarded 25+ active clients, and strengthened its Virtual CFO & compliance offerings.</p>
          </div>
          <div className="timeline-year">
            <div className="icon"><img src="/images/milestone3.png" alt="2025" /></div>
            <h3>2025</h3>
            <p>FINTEXL crossed the 50+ client mark, built long-term partnerships with corporates, and began digital transformation projects to automate compliance and financial reporting processes.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;








